import { useState, useEffect } from 'react';
import './Login.css';

export default function Login({ onLogin, onToken }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // 🔐 Verificação de token na URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      setIsLoading(true);
      onToken(token)
        .then(() => {
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Erro ao verificar token:', error);
          setIsLoading(false);
        });
    }
  }, [onToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const userData = { username, password, role: 'admin' };
      await onLogin(userData);
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      alert('Falha ao autenticar usuário. Verifique suas credenciais.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">
            <svg fill="#FFF" width="48px" height="48px" viewBox="0 -10.44 126.72 126.72" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="M18.78,0h89.16c5.17,0,9.86,2.11,13.27,5.52c3.4,3.4,5.52,8.1,5.52,13.27v76.29c0,0.79-0.32,1.5-0.84,2.02 c-0.52,0.52-1.23,0.84-2.02,0.84h-7.44v6.99c0,0.51-0.41,0.92-0.92,0.92H95.83c-0.51,0-0.92-0.41-0.92-0.92v-6.98H33.86v6.99 c0,0.51-0.41,0.92-0.92,0.92H13.27c-0.51,0-0.92-0.41-0.92-0.92v-6.98H2.86c-0.78,0-1.5-0.32-2.02-0.84H0.84 C0.32,96.58,0,95.86,0,95.08V18.78c0-5.17,2.11-9.86,5.52-13.27C8.92,2.11,13.62,0,18.78,0L18.78,0z M63.92,53.94h11.43 c2.25,0,4.07,0.31,5.46,0.92c1.39,0.61,2.53,1.49,3.44,2.63c0.9,1.15,1.56,2.47,1.96,3.99c0.41,1.52,0.61,3.12,0.61,4.82 c0,2.66-0.3,4.72-0.91,6.19c-0.6,1.47-1.44,2.69-2.52,3.69c-1.08,0.99-2.23,1.65-3.47,1.98c-1.69,0.45-3.22,0.68-4.58,0.68H63.92 V53.94L63.92,53.94z M71.61,59.57v13.6h1.89c1.61,0,2.76-0.18,3.44-0.53c0.68-0.36,1.21-0.98,1.6-1.87 c0.39-0.89,0.58-2.33,0.58-4.32c0-2.64-0.43-4.44-1.29-5.41c-0.86-0.97-2.29-1.46-4.29-1.46H71.61L71.61,59.57z M46.8,61.14 l-6.54-1.17c0.54-2.08,1.58-3.67,3.13-4.79c1.54-1.11,3.73-1.66,6.55-1.66c3.25,0,5.59,0.6,7.04,1.81 c1.44,1.21,2.17,2.74,2.17,4.57c0,1.07-0.3,2.05-0.88,2.92c-0.59,0.87-1.47,1.63-2.65,2.29c0.96,0.24,1.7,0.52,2.2,0.83 c0.83,0.51,1.47,1.18,1.92,2.01c0.46,0.83,0.69,1.83,0.69,2.98c0,1.45-0.38,2.84-1.14,4.17c-0.76,1.33-1.85,2.35-3.27,3.07 c-1.43,0.72-3.3,1.08-5.62,1.08c-2.26,0-4.05-0.27-5.35-0.8c-1.31-0.53-2.38-1.31-3.23-2.34c-0.84-1.03-1.49-2.32-1.94-3.87 l6.92-0.92c0.27,1.4,0.69,2.37,1.26,2.91c0.57,0.54,1.29,0.81,2.18,0.81c0.92,0,1.69-0.34,2.31-1.02c0.61-0.68,0.92-1.58,0.92-2.72 c0-1.15-0.3-2.05-0.89-2.68c-0.59-0.63-1.4-0.95-2.41-0.95c-0.54,0-1.29,0.13-2.23,0.41l0.36-4.94c0.38,0.06,0.67,0.09,0.89,0.09 c0.89,0,1.64-0.29,2.24-0.86c0.6-0.57,0.9-1.25,0.9-2.04c0-0.76-0.23-1.36-0.67-1.81c-0.45-0.45-1.07-0.68-1.85-0.68 c-0.81,0-1.47,0.24-1.98,0.74C47.32,59.06,46.98,59.91,46.8,61.14L46.8,61.14z M59.94,44.72h7.52l-1.45,5.38H61.3L59.94,44.72 L59.94,44.72z M17.6,25.86h31.63l-2.51-4.25h2.4h31.52l-2.44,4.25h30.92c-0.05-2.92-1.26-5.57-3.2-7.51 c-1.97-1.97-4.7-3.2-7.69-3.2H28.48c-2.99,0-5.71,1.23-7.69,3.2C18.86,20.29,17.65,22.94,17.6,25.86L17.6,25.86z M109.12,35.32 H72.77l-4.45,7.74h-8.93l-4.57-7.74H17.6v47.46h91.52V35.32L109.12,35.32z M75.91,24.36H51.53l9.42,15.94h5.79L75.91,24.36 L75.91,24.36z M28.48,11.32h69.75c4.05,0,7.73,1.66,10.4,4.32c2.67,2.67,4.32,6.35,4.32,10.4v57.94c0,0.73-0.3,1.39-0.77,1.86l0,0 c-0.48,0.48-1.14,0.78-1.86,0.78H16.39c-0.72,0-1.39-0.3-1.86-0.77c-0.48-0.48-0.77-1.14-0.77-1.86V26.04 c0-4.05,1.66-7.73,4.32-10.4C20.75,12.97,24.43,11.32,28.48,11.32L28.48,11.32z M107.94,3.84H18.78c-4.11,0-7.84,1.68-10.55,4.39 c-2.71,2.71-4.39,6.44-4.39,10.55V94.1h119.04V18.78c0-4.11-1.68-7.84-4.39-10.55C115.78,5.52,112.05,3.84,107.94,3.84L107.94,3.84 z"/>
              </g>
            </svg>
          </div>
          <h1 className="login-title">OS Genius 3D Library</h1>
          <p className="login-description">
            Faça login para acessar a biblioteca de modelos 3D
          </p>
        </div>
        <div className="login-content">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username" className="form-label">Usuário</label>
              <input
                id="username"
                type="text"
                className="form-input"
                placeholder="Digite seu usuário"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="form-label">Senha</label>
              <input
                id="password"
                type="password"
                className="form-input"
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button 
              type="submit" 
              className="login-button" 
              disabled={isLoading}
            >
              {isLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
          <div className="login-footer">
            <p>
              Utilize as mesmas credenciais do APP{' '}
              <strong>
                <a 
                  href='https://play.google.com/store/apps/details?id=com.gigadigital.osGeniusApp&pcampaignid=3dlib'
                  target="_blank"
                  rel="noopener noreferrer"
                  className="login-link"
                >
                  OS Genius
                </a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
